import { Phone } from "lucide-react";
import { TEL_LINK, WA_LINK } from "@/lib/site";
import { WhatsAppIcon } from "./icons";

export const FloatingBar = () => (
  <>
    <div
      data-testid="floating-call-bar"
      className="lg:hidden fixed bottom-0 inset-x-0 z-50 grid grid-cols-2 shadow-2xl"
    >
      <a
        data-testid="floating-bar-call-button"
        href={TEL_LINK}
        className="flex items-center justify-center gap-2 bg-ink text-white py-4 text-sm font-bold"
      >
        <Phone className="w-4 h-4" /> Call Karein
      </a>
      <a
        data-testid="floating-bar-whatsapp-button"
        href={WA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center gap-2 bg-wa text-white py-4 text-sm font-bold"
      >
        <WhatsAppIcon className="w-4 h-4" /> WhatsApp
      </a>
    </div>

    <div className="hidden lg:flex flex-col gap-3 fixed bottom-8 right-8 z-50">
      <a
        data-testid="floating-whatsapp-button"
        href={WA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp par baat karein"
        className="grid place-items-center w-14 h-14 rounded-full bg-wa text-white shadow-xl hover:scale-110 transition-transform"
      >
        <WhatsAppIcon className="w-6 h-6" />
      </a>
      <a
        data-testid="floating-phone-button"
        href={TEL_LINK}
        aria-label="Call karein"
        className="call-pulse grid place-items-center w-14 h-14 rounded-full bg-brand text-white shadow-xl hover:scale-110 transition-transform"
      >
        <Phone className="w-6 h-6" />
      </a>
    </div>
  </>
);
